import React from "react";
import AtlaskitSelect from "@atlaskit/select";
import { SelectContainer } from "./styles";

function Select({
  value,
  onChange = () => {},
  options = [],
  placeholder = "",
  isMulti = false,
}) {
  return (
    <SelectContainer>
      <AtlaskitSelect
        value={value}
        options={options}
        onChange={onChange}
        placeholder={placeholder}
        isMulti={isMulti}
        classNamePrefix="caelor-custom-select"
      />
    </SelectContainer>
  );
}

export default Select;
